import React from 'react';
import Text from '../../../Text';
export const Price = _ref => {
  let {
    children,
    mode,
    priceMobile
  } = _ref;
  if (!children) {
    return React.createElement("div", {
      style: {
        height: '27px'
      }
    });
  }
  return React.createElement(Text.BodyLarge, {
    tag: "h3",
    weight: "semibold",
    className: "".concat(mode, " ").concat(priceMobile ? 'priceMobile' : '', " price")
  }, children);
};